<template>
  <div>
    <OrganisationCard
      v-for="organisation in organisations"
      :key="organisation.id"
      :organisation="organisation"
      @fetchData="fetchData"
    />
  </div>
</template>
<script setup>
import OrganisationCard from '@/components/adminTool/OrganisationCard.vue'

defineProps({
  organisations: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['fetchData'])
const fetchData = () => emit('fetchData')
</script>
